
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/radar-metric-labels",
      function () {
        return require("private-next-pages/x/api/charts/radar-metric-labels.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/radar-metric-labels"])
      });
    }
  